import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import * as Sentry from "@sentry/react";

import ErrorDisplay from "components/ErrorDisplay";

export default function ErrorPage() {
  const error = useRouteError();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  const message =
    typeof error === "string"
      ? error
      : (error as { statusText?: string; message?: string })?.statusText ||
        (error as { message?: string })?.message ||
        "An unknown error occurred.";

  return <ErrorDisplay message={message} />;
}
